import styled from "styled-components";

export const UserEngagementContainer = styled.div`
  flex: 0 0 30%;
  border-radius: 6px;
  background-color: ${({ theme }) => theme.colors.white};
  padding-top: 1.2rem;
`;
